import React from "react";
import styled, { withTheme } from "styled-components";
import PropTypes from "prop-types";
import Icon from "../Icon";

const ScrollMore = ({ className, onClick, theme }) => {
  return (
    <div className={className}>
      <button onClick={onClick} aria-label="Sroll para baixo">
        <Icon
          name={theme.icons.chevron_down}
          size="medium"
          color={theme.components.scrollMore.iconColor}
        />
      </button>
    </div>
  );
};

ScrollMore.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.object,
  onClick: PropTypes.func
};

const ScrollMoreWithStyles = styled(ScrollMore)`
  height: ${props => props.height || "50px"};
  width: 100%;
  position: ${props => props.position || "relative"};
  bottom: ${props => props.bottom || "initial"};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  button {
    background-color: transparent;
    height: 100%;
    width: 100%;
    border: none;
    cursor: pointer;
    i {
      -webkit-animation: bouncey 1.6s linear infinite;
      animation: bouncey 1.6s linear infinite;
    }
  }

  @keyframes bouncey {
    0% {
      transform: translateY(0);
      -webkit-transform: translateY(0);
      -moz-transform: translateY(0);
    }
    50% {
      transform: translateY(4px);
      -webkit-transform: translateY(4px);
      -moz-transform: translateY(4px);
    }
    100% {
      transform: translateY(0);
      -webkit-transform: translateY(0);
      -moz-transform: translateY(0);
    }
  }
`;

export default withTheme(ScrollMoreWithStyles);
